import { Controller } from "stimulus"

// Stimulus 1.1 controller for managing the Seat modal term fields visibility
// Responsibilities:
// - Parse the list of office IDs which already have an active/upcoming unseated term
// - Listen for changes to office_id radios within the modal
// - Show/hide the manual term fields and toggle required attributes accordingly
export default class extends Controller {
  static get targets() {
    return ["termFields"]
  }

  connect() {
    // Parse offices-with-term ids from data attribute
    this.officesWithTerm = this._parseOfficesWithTerm(this.data.get("offices-with-term"))

    // Cache inputs inside term fields to toggle required attr
    this.termNameInput = this._findInput("term_name")
    this.termStartInput = this._findInput("term_start_date")
    this.termEndInput = this._findInput("term_end_date")

    // Initial hidden/required state
    this._hideTermFields()
    this._setTermFieldsRequired(false)

    // If a radio is already checked, sync state
    const radios = this._radios()
    const prechecked = Array.prototype.find.call(radios, (r) => r.checked)
    if (prechecked) this._updateVisibilityForOffice(prechecked.value)
  }

  // Handles change events bubbling from within the modal
  onChange(event) {
    const target = event.target
    if (target && target.matches('input[type="radio"][name="office_id"]')) {
      this._updateVisibilityForOffice(target.value)
    }
  }

  // Helpers
  _radios() {
    return this.element.querySelectorAll('input[type="radio"][name="office_id"]')
  }

  _findInput(name) {
    return this.hasTermFieldsTarget
      ? this.termFieldsTarget.querySelector(`[name="${name}"]`)
      : null
  }

  _parseOfficesWithTerm(value) {
    // Accept comma-separated numbers (e.g., "1,2,3") or JSON array
    if (!value) return new Set()
    try {
      const parsed = JSON.parse(value)
      if (Array.isArray(parsed)) return new Set(parsed.map((n) => Number(n)))
    } catch (e) {
      // fall through to CSV parsing
    }
    return new Set(
      String(value)
        .split(',')
        .map((s) => s.trim())
        .filter((s) => s.length > 0)
        .map((n) => Number(n))
    )
  }

  _setTermFieldsRequired(isRequired) {
    if (this.termNameInput) this.termNameInput.required = isRequired
    if (this.termStartInput) this.termStartInput.required = isRequired
    if (this.termEndInput) this.termEndInput.required = isRequired
  }

  _showTermFields() {
    if (this.hasTermFieldsTarget) this.termFieldsTarget.classList.remove('hidden')
  }

  _hideTermFields() {
    if (this.hasTermFieldsTarget) this.termFieldsTarget.classList.add('hidden')
  }

  _updateVisibilityForOffice(officeId) {
    const needsManualTerm = !this.officesWithTerm.has(Number(officeId))
    if (needsManualTerm) {
      this._showTermFields()
      this._setTermFieldsRequired(true)
    } else {
      this._hideTermFields()
      this._setTermFieldsRequired(false)
    }
  }
}
